import { render, staticRenderFns } from "./Tip1.vue?vue&type=template&id=0226a42d&scoped=true&"
import script from "./Tip1.vue?vue&type=script&lang=js&"
export * from "./Tip1.vue?vue&type=script&lang=js&"
import style0 from "./Tip1.vue?vue&type=style&index=0&id=0226a42d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0226a42d",
  null
  
)

export default component.exports